import {
  ArrowRight,
  CheckCircle2,
  CalendarDays,
  BellRing,
  LayoutDashboard,
} from "lucide-react";
import ContactForm from "./ContactForm";

const bullets = [
  "Primești cererile într-un flux mai clar, fără haos între WhatsApp, telefon și Facebook",
  "Ai o prezentare profesională, optimizată pentru mobil și pregătită pentru promovare",
  "Poți începe simplu, cu email direct, sau poți merge spre varianta Pro cu administrare dedicată",
];

export default function HeroSection({ publicConfig }) {
  return (
    <section
      className="rz-hero"
      id="top"
      style={{ backgroundImage: "url('/images/bg.webp')" }}
    >
      <div className="rz-hero__overlay"></div>

      <div className="rz-shell rz-hero__content">
        <div className="rz-hero__copy">
          <div className="rz-eyebrow">Rezervări și programări directe, într-un flux mai clar</div>

          <h1>
            Nu îți promitem magie. <br />
            <span>Îți construim un sistem clar prin care să pierzi mai puține cereri.</span>
          </h1>

          <p>
            Rezervix este potrivit pentru businessurile care au deja interes din online, dar au nevoie de o prezentare mai bună, un flux mai clar pentru cereri și mai mult control asupra modului în care acestea ajung la tine.
          </p>

          <ul className="rz-hero__bullets">
            {bullets.map((item) => (
              <li key={item}>
                <CheckCircle2 size={18} />
                {item}
              </li>
            ))}
          </ul>

          <div className="rz-hero__actions">
            <a href="#lead-form" className="rz-btn rz-btn--primary">
              Solicită o prezentare
              <ArrowRight size={16} />
            </a>

            <a href="#clienti" className="rz-btn rz-btn--ghost">
              Vezi exemple de prezentare
            </a>
          </div>

          <div className="rz-hero__floating rz-hero__floating--inline">
            <div className="rz-floating-card">
              <CalendarDays size={18} />
              <div>
                <strong>Cereri mai clare</strong>
                <span>Clientul găsește informațiile mai repede și trimite o solicitare într-un mod simplu.</span>
              </div>
            </div>

            <div className="rz-floating-card">
              <BellRing size={18} />
              <div>
                <strong>Mai puține mesaje pierdute</strong>
                <span>Centralizezi mai bine interesul existent și răspunzi mai ușor la timp.</span>
              </div>
            </div>

            <div className="rz-floating-card">
              <LayoutDashboard size={18} />
              <div>
                <strong>Control pe măsura businessului tău</strong>
                <span>Alegi varianta Basic sau Pro, în funcție de cât control vrei asupra cererilor.</span>
              </div>
            </div>
          </div>
        </div>

        <div className="rz-hero__visuals">
          <ContactForm publicConfig={publicConfig} />
        </div>
      </div>
    </section>
  );
}
